var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViceCaptain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0.939331C3.584 0.939331 0 4.52333 0 8.93933C0 13.3553 3.584 16.9393 8 16.9393C12.416 16.9393 16 13.3553 16 8.93933C16 4.52333 12.416 0.939331 8 0.939331Z",
    fill: "#FF0F9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4.93933H5.35337C5.49889 4.93933 5.61739 4.97382 5.70886 5.04279C5.80033 5.11176 5.86893 5.20102 5.91467 5.31056L8.03515 10.6782C8.10584 10.8527 8.1734 11.0444 8.23785 11.2533C8.30229 11.4622 8.36362 11.6823 8.42183 11.9136C8.51746 11.447 8.63596 11.0352 8.77732 10.6782L10.8916 5.31056C10.929 5.21725 10.9955 5.13205 11.0911 5.05496C11.1868 4.97787 11.3053 4.93933 11.4466 4.93933H12.8L9.15776 13.7393H7.64224L4 4.93933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViceCaptain);
export default __webpack_public_path__ + "static/media/IconViceCaptain.d3d28f73095c372ff44136a6112e5022.svg";
export { ForwardRef as ReactComponent };